import React, {Component} from 'react';
import {connect} from 'react-redux';
import EnabledOffer from "../../components/EnabledOffer/enalbedOffer";
import {
    changeClientOverviewStoreSettings,
    deleteEnabledOffer,
    getClientEnabledOfferById
} from "../../actions/clientOverview";
import {parseClientOverview, parseLogin} from "../../helpers/parseImmutables";

class EnabledOfferHOC extends Component {

    componentDidMount(){
        if(this.props.match.params.id){
            this.props.getClientEnabledOfferById({
                enabledOfferId: this.props.match.params.id
            })
        }

    }

    render(){
        return (
            <EnabledOffer
                {...this.props}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        enabledOffer: parseClientOverview(state.clientOverview).enabledOffer,
        deleteEnabledOfferResponse: parseClientOverview(state.clientOverview).deleteEnabledOfferResponse,
        useRole: parseLogin(state.login).userInfo.role
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getClientEnabledOfferById: (payload) => {
            dispatch(getClientEnabledOfferById(payload))
        },
        deleteEnabledOffer: (payload) => {
            dispatch(deleteEnabledOffer(payload))
        },
        changeClientOverviewStoreSettings: (payload) => {
            dispatch(changeClientOverviewStoreSettings(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EnabledOfferHOC)


// WEBPACK FOOTER //
// ./src/containers/EnabledOffer/enableedOfferHOC.js